import { render, staticRenderFns } from "./social_sharing.vue?vue&type=template&id=e85e926a"
import script from "./social_sharing.vue?vue&type=script&lang=js"
export * from "./social_sharing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports